import { render } from "./sichuan.vue?vue&type=template&id=150fc38d&scoped=true&ts=true"
import script from "./sichuan.vue?vue&type=script&lang=ts"
export * from "./sichuan.vue?vue&type=script&lang=ts"

import "./sichuan.vue?vue&type=style&index=0&id=150fc38d&lang=scss&scoped=true"

import exportComponent from "/Users/wangyong/shanggeyun/code/sagacloud-sagacare-ipad/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150fc38d"]])

export default __exports__